import React, { useMemo } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { StaticImage } from 'gatsby-plugin-image'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { useIsMobile } from '../../../theme/useIsMobile'
import { useIsLg } from '../../../theme/useIsLg'
import { useIsMd } from '../../../theme/useIsMd'
import { WeKeepAnEyeOutForSection } from './WeKeepAnEyeOutForSection'

export function WeKeepAnEyeOutFor() {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const isMdOrUp = useIsMd()
  const isLgOrUp = useIsLg()

  const alertsInformation = [
    {
      id: 0,
      title: t('weKeepAnEyeOutForItems.0'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/cash.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 1,
      title: t('weKeepAnEyeOutForItems.1'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/cash.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 2,
      title: t('weKeepAnEyeOutForItems.2'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/cash.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 3,
      title: t('weKeepAnEyeOutForItems.3'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/arrow-up.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 4,
      title: t('weKeepAnEyeOutForItems.4'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/arrow-up.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 5,
      title: t('weKeepAnEyeOutForItems.5'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/union.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 6,
      title: t('weKeepAnEyeOutForItems.6'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/arrow-down.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 7,
      title: t('weKeepAnEyeOutForItems.7'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/atm.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 8,
      title: t('weKeepAnEyeOutForItems.8'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/cash.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 9,
      title: t('weKeepAnEyeOutForItems.9'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/cash.png"
          alt="Cash icon"
        />
      ),
    },
    {
      id: 10,
      title: t('weKeepAnEyeOutForItems.10'),
      icon: (
        <StaticImage
          height={20}
          src="../../../../static/images/we-keep-an-eye-out-for/cash.png"
          alt="Cash icon"
        />
      ),
    },
  ]

  const slidesToShow = useMemo(() => {
    if (isMobile) {
      return 1
    }
    if (isLgOrUp) {
      return 4
    }
    if (isMdOrUp) {
      return 3
    }
    return 2
  }, [isMobile, isLgOrUp, isMdOrUp])

  const carouselSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    cssEase: 'linear',
    accessibility: false,
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  }

  return (
    <WeKeepAnEyeOutForSection
      carouselSettings={carouselSettings}
      alertsInformation={alertsInformation}
    />
  )
}

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      style={{
        ...style,
        display: 'block',
        width: '50px',
        height: '50px',
      }}
      onClick={onClick}
      className={className}
    >
      <path
        d="M37.8164 42.5121L26.18 32.3303L37.8164 22.1484"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="0.5"
        y="0.830078"
        width="63"
        height="63"
        rx="15.5"
        stroke="white"
        strokeOpacity="0.1"
      />
    </svg>
  )
}

function NextArrow(props) {
  const { className, style, onClick } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      style={{
        ...style,
        display: 'block',
        width: '50px',
        height: '50px',
      }}
      onClick={onClick}
      className={className}
    >
      <path
        d="M26.1836 42.5121L36.3654 32.3303L26.1836 22.1484"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="0.5"
        y="0.830078"
        width="63"
        height="63"
        rx="15.5"
        stroke="white"
        strokeOpacity="0.1"
      />
    </svg>
  )
}
